import { useEffect } from 'react';
import { noop } from 'lodash-es';
import { useStore, useStoreActions } from '~/contexts';
import { useIoContext } from '~/providers/IoContext';
import { useFeatureFlags } from './useFeatureFlags';
import { useRegisterMobileNotification } from './useRegisterMobileNotification';
export const useNativePush = ()=>{
    const { native, getNow } = useIoContext();
    const { NATIVE_PUSH } = useFeatureFlags();
    const authToken = useStore((state)=>state.authToken);
    const pushEnabled = !!NATIVE_PUSH && native.push.isAvailable && authToken != null;
    const { registerMobileNotification } = useRegisterMobileNotification();
    const { setNativePushTokenInfo } = useStoreActions();
    useEffect(()=>{
        if (pushEnabled) {
            const { push } = native;
            let lastPostedToken = null;
            const onToken = (info)=>{
                setNativePushTokenInfo(info);
                if (info.token === lastPostedToken) {
                    return;
                }
                lastPostedToken = info.token;
                const registeredAt = getNow();
                registerMobileNotification(info, {
                    onSuccess: ()=>{
                        native.pushRemovalOutbox.clearForToken(info.token, registeredAt).catch(noop);
                    },
                    onError: ()=>{
                        lastPostedToken = null;
                    }
                });
            };
            const removeTokenListenerPromise = push.registerTokenListener(onToken);
            void removeTokenListenerPromise.then(()=>push.requestPermissionAndRegister()).catch(()=>undefined);
            const removeResumeListener = native.lifecycle.registerResumeListener(()=>{
                void push.requestPermissionAndRegister().catch(()=>undefined);
            });
            return ()=>{
                void removeTokenListenerPromise.then((removeListener)=>removeListener()).catch(()=>undefined);
                removeResumeListener();
            };
        }
        return undefined;
    }, [
        pushEnabled,
        registerMobileNotification
    ]);
};
